import { JsonHelper } from "../../helpers";

export default class CategoryContent {
    id;
    title;
    language;
    slug;
    email;
    label;
    summary;
    highlights = [];
    value;
    image;
    header_image;
    svg;
    url;
    button_text;
    views;

    static fromJson(json) {
        let categoryContent = new CategoryContent();
        categoryContent.id = json['id'];
        categoryContent.title = json['title'];
        categoryContent.language = json['language'];
        categoryContent.slug = json['slug'];
        categoryContent.label = json.label ? json.label : '';
        categoryContent.email = json['email'];
        categoryContent.summary = json.summary ? json.summary : '';
        categoryContent.highlights = JsonHelper.tryParse(json['highlights'], []);
        categoryContent.value = json['value'] != null ? json['value'] : '{}';
        categoryContent.image = json['image'];
        categoryContent.header_image = json['header_image'];
        categoryContent.svg = json['svg'];
        categoryContent.url = json['url'];
        categoryContent.button_text = json['button_text'] ? json['button_text'] : '';
        categoryContent.views = json['views'];
        return categoryContent;
    }
}
